
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CommunicationLogEntryDtoModel extends Model<CommunicationLogEntryDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskActionId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'comment', type: 'string' },
		{ name: 'userIdsToNotify', type: 'string[]', isArray: true },
		{ name: 'additionalData', type: 'any' }
	];
	[key: string]: any;
	
	public taskActionId?: string;
	public taskflowId?: string;
	public companyId?: string;
	public comment: string;
	public userIdsToNotify: string[];
	public additionalData?: any;
    
	constructor(){
		super();
		this.taskActionId = undefined;
		this.taskflowId = undefined;
		this.companyId = undefined;
		this.comment = '';
		this.userIdsToNotify = [];
		this.additionalData = undefined;
		
	}
	getProperties(){
		return CommunicationLogEntryDtoModel.classProperties;
	}
}

